import React from 'react'
import styled from 'styled-components'
import Button from 'core-system/Button'
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'core-system/Modal'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { Bike } from 'redux/bikeCatalog/bikeCatalogTypes'
import { formatBikePrice } from '../utils'
import NonDirectCheckoutHelper, {
  formatVendorName,
} from '../shared/components/NonDirectCheckoutHelper'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const BikeDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  border-radius: 0.75rem;
  background-color: ${palette.secondary.purple100};
`

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

const BackLink = styled.button`
  border: 0;
  background: transparent;
  color: ${palette.secondary.purple700};
  cursor: pointer;
  font-weight: 600;
  padding: 0;
`

interface NonDirectCheckoutModalProps {
  open: boolean
  bike: Bike | null
  isLoading: boolean
  onClose: () => void
  onContinue: () => void
}

const NonDirectCheckoutModal = React.memo(
  (props: NonDirectCheckoutModalProps) => {
    const { open, bike, isLoading, onClose, onContinue } = props

    if (!bike) {
      return null
    }

    const vendorName = formatVendorName(bike.vendor)

    return (
      <Modal open={open} onClose={onClose} width='32rem'>
        <ModalHeader title={`You're headed to ${vendorName}`} />
        <ModalBody>
          <Content>
            <BikeDetails>
              <Text variant='h4'>{bike.name}</Text>
              <Text variant='body2' textColor={palette.text.secondary}>
                {bike.manufacturer}
                {bike.vehicleType ? ` - ${bike.vehicleType}` : ''}
              </Text>
              <Text variant='action2'>{formatBikePrice(bike.monthlyPrice)}</Text>
            </BikeDetails>
            <NonDirectCheckoutHelper bike={bike} />
          </Content>
        </ModalBody>
        <ModalFooter>
          <FooterContent>
            <BackLink type='button' onClick={onClose}>
              &larr; Back to catalog
            </BackLink>
            <Button onClick={onContinue} disabled={isLoading}>
              {isLoading ? 'Opening checkout...' : `Continue to ${vendorName}`}
            </Button>
          </FooterContent>
        </ModalFooter>
      </Modal>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  NonDirectCheckoutModal.displayName = 'NonDirectCheckoutModal'
}

export default NonDirectCheckoutModal
